import { render, staticRenderFns } from "./activeNewOld.vue?vue&type=template&id=2f1b20c5&scoped=true"
import script from "./activeNewOld.vue?vue&type=script&lang=js"
export * from "./activeNewOld.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1b20c5",
  null
  
)

export default component.exports